import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { work } from "../mock";

export default function SelectedWork() {
  return (
    <section id="work" className="relative overflow-hidden bg-transparent pb-24 md:pb-32">
      <div className="mx-auto max-w-[1500px] px-5 md:px-10">
        <div className="reveal mb-10 flex flex-wrap items-center justify-between gap-4">
          <div>
            <h2 className="font-display text-5xl text-white sm:text-6xl md:text-7xl">{work.kicker}</h2>
            <p className="mono-label mt-3 text-xs text-[var(--crtr-yellow)]">{work.intro}))</p>
          </div>
          <a href="#work" className="group inline-flex items-center gap-3 rounded-full border border-[var(--crtr-yellow)] py-2.5 pl-5 pr-2.5">
            <span className="mono-label text-xs text-[var(--crtr-yellow)]">VIEW ALL WORK</span>
            <span className="flex h-7 w-7 items-center justify-center rounded-full bg-[var(--crtr-yellow)]">
              <ArrowRight className="h-4 w-4 text-black transition-transform group-hover:translate-x-0.5" />
            </span>
          </a>
        </div>

        <div className="grid gap-4 md:grid-cols-3">
          {work.cases.map((c) => {
            const Card = c.link ? Link : "a";
            const linkProps = c.link ? { to: c.link, "data-testid": `work-card-${c.link.split("/").pop()}` } : { href: "#work" };
            return (
            <Card key={c.id} {...linkProps} className="group relative block aspect-[3/4] overflow-hidden rounded-2xl bg-neutral-900">
              {c.video ? (
                <video
                  src={c.video}
                  poster={c.image}
                  autoPlay
                  muted
                  loop
                  playsInline
                  preload="metadata"
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              ) : (
                <img loading="lazy" src={c.image} alt={c.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/10 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 flex items-end justify-between p-6">
                <div>
                  <h3 className="font-heavy text-2xl uppercase text-white">{c.id}</h3>
                  <p className="mono-label mt-1 text-xs text-white/80">{c.title}</p>
                </div>
                <span className="flex h-10 w-10 flex-none items-center justify-center rounded-full border border-[var(--crtr-yellow)] text-[var(--crtr-yellow)] transition-colors group-hover:bg-[var(--crtr-yellow)] group-hover:text-black">
                  <ArrowRight className="h-5 w-5" />
                </span>
              </div>
            </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
}
